import { Alert, Button, Card, Divider, Snackbar } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import LoadingIcon from "../components/LoadingIcon";

const Subscription = () => {
  const token = localStorage.getItem("token");
  const [amount1, setAmount1] = useState();
  const [amount2, setAmount2] = useState();
  const [amount3, setAmount3] = useState();
  const [amount4, setAmount4] = useState();
  const [amount5, setAmount5] = useState();
  const [message, setMessage] = useState("");
  const [disable, setDisable] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [type, setType] = useState("success");
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(0.0);
  const vertical = "top";
  const horizontal = "center";

  const getActivity = useCallback(async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}activity/withdraw`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );
    const data = await response.json();

    if (data.status) {
      setBalance(data.userBalance);
    }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    getActivity();
  }, [getActivity]);

  const handleSubmit = async (e, value) => {
    setDisable(true);
    e.preventDefault();
    let amount;

    switch (value) {
      case 1:
        amount = amount1;
        break;
      case 2:
        amount = amount2;
        break;
      case 3:
        amount = amount3;
        break;
      case 4:
        amount = amount4;
        break;
      case 5:
        amount = amount5;
        break;

      default:
        break;
    }

    if (parseInt(amount) > parseInt(balance)) {
      setType("error");
      setMessage(
        "You have $" + balance + " available to purchase a subscription"
      );
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 4000);
      setDisable(false);
    } else {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}subscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            value,
            amount,
          }),
        }
      );

      const data = await response.json();

      if (data.status) {
        setType("success");
        setMessage("Subscription added");
        setShowNotification(true);
        setTimeout(() => setShowNotification(false), 4000);
      } else {
        setType("error");
        setMessage(data.message);
        setShowNotification(true);
        setTimeout(() => setShowNotification(false), 4000);
      }
      setDisable(false);
    }
  };

  return (
    <div>
      <div className="mb-9">
        <h3 className="font-bold text-2xl text-white">Subscription Plans</h3>
      </div>
      {loading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <div className="container">
          <div className="mb-9">
            <h6 className="font-bold text-white">
              Amount Available to purchase a subscription:{" "}
              <span className="text-green-600">${balance}</span>{" "}
            </h6>
          </div>
          <Snackbar
            open={showNotification}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert message={message} severity={type}>
              {message}
            </Alert>
          </Snackbar>
          <div className="row">
            <div className="col-md-4 mb-10">
              <Card
                sx={{ minHeight: 300 }}
                className="!bg-[#1B4242] !text-white"
              >
                <div className="mb-4 text-center mt-3">
                  <h3 className="font-bold">Startup</h3>
                </div>
                <Divider />
                <div className="w-full text-center mt-9">
                  <div className="font-bold mb-2">MINIMUM DEPOSIT $500.00</div>
                  {/* <div className="font-bold">20%</div> */}
                  <Form
                    className="px-2 mt-3"
                    onSubmit={(e) => handleSubmit(e, 1)}
                  >
                    <Form.Group className="mb-3">
                      <Form.Control
                        onChange={(e) => setAmount1(e.target.value)}
                        type="number"
                        // max={balance}
                        min={300}
                        placeholder="Enter Amount"
                        required
                        disabled={disable}
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      className="w-full !bg-[#101010]"
                      variant="contained"
                      disabled={disable}
                    >
                      Subscribe
                    </Button>
                  </Form>
                </div>
              </Card>
            </div>
            <div className="col-md-4 mb-10">
              <Card
                sx={{ minHeight: 300 }}
                className="!bg-[#1B4242] !text-white"
              >
                <div className="mb-4 text-center mt-3">
                  <h3 className="font-bold">Standard</h3>
                </div>
                <Divider />
                <div className="w-full text-center mt-9">
                  <div className="font-bold mb-2">
                    MINIMUM DEPOSIT $1,500.00
                  </div>
                  {/* <div className="font-bold">40%</div> */}
                  <Form
                    className="px-2 mt-3"
                    onSubmit={(e) => handleSubmit(e, 2)}
                  >
                    <Form.Group className="mb-3">
                      <Form.Control
                        onChange={(e) => setAmount2(e.target.value)}
                        type="number"
                        max={balance}
                        min={1500}
                        placeholder="Enter Amount"
                        required
                        disabled={disable}
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      className="w-full !bg-[#101010]"
                      variant="contained"
                      disabled={disable}
                    >
                      Subscribe
                    </Button>
                  </Form>
                </div>
              </Card>
            </div>
            <div className="col-md-4 mb-10">
              <Card
                sx={{ minHeight: 300 }}
                className="!bg-[#1B4242] !text-white"
              >
                <div className="mb-4 text-center mt-3">
                  <h3 className="font-bold">Premium</h3>
                </div>
                <Divider />
                <div className="w-full text-center mt-9">
                  <div className="font-bold mb-2">
                    MINIMUM DEPOSIT $3,000.00
                  </div>
                  {/* <div className="font-bold">60%</div> */}
                  <Form
                    className="px-2 mt-3"
                    onSubmit={(e) => handleSubmit(e, 3)}
                  >
                    <Form.Group className="mb-3">
                      <Form.Control
                        onChange={(e) => setAmount3(e.target.value)}
                        type="number"
                        max={balance}
                        min={3000}
                        placeholder="Enter Amount"
                        required
                        disabled={disable}
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      className="w-full !bg-[#101010]"
                      variant="contained"
                      disabled={disable}
                    >
                      Subscribe
                    </Button>
                  </Form>
                </div>
              </Card>
            </div>
            <div className="col-md-4 mb-10">
              <Card
                sx={{ minHeight: 300 }}
                className="!bg-[#1B4242] !text-white"
              >
                <div className="mb-4 text-center mt-3">
                  <h3 className="font-bold">Silver</h3>
                </div>
                <Divider />
                <div className="w-full text-center mt-9">
                  <div className="font-bold mb-2">
                    MINIMUM DEPOSIT $5,000.00
                  </div>
                  {/* <div className="font-bold">80%</div> */}
                  <Form
                    className="px-2 mt-3"
                    onSubmit={(e) => handleSubmit(e, 4)}
                  >
                    <Form.Group className="mb-3">
                      <Form.Control
                        onChange={(e) => setAmount4(e.target.value)}
                        type="number"
                        max={balance}
                        min={5000}
                        placeholder="Enter Amount"
                        required
                        disabled={disable}
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      className="w-full !bg-[#101010]"
                      variant="contained"
                      disabled={disable}
                    >
                      Subscribe
                    </Button>
                  </Form>
                </div>
              </Card>
            </div>
            <div className="col-md-4 mb-10">
              <Card
                sx={{ minHeight: 300 }}
                className="!bg-[#1B4242] !text-white"
              >
                <div className="mb-4 text-center mt-3">
                  <h3 className="font-bold">Gold</h3>
                </div>
                <Divider />
                <div className="w-full text-center mt-9">
                  <div className="font-bold mb-2">
                    MINIMUM DEPOSIT $25,000.00
                  </div>
                  {/* <div className="font-bold">100%</div> */}
                  <Form
                    className="px-2 mt-3"
                    onSubmit={(e) => handleSubmit(e, 5)}
                  >
                    <Form.Group className="mb-3">
                      <Form.Control
                        onChange={(e) => setAmount5(e.target.value)}
                        type="number"
                        max={balance}
                        min={25000}
                        placeholder="Enter Amount"
                        required
                        disabled={disable}
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      className="w-full !bg-[#101010]"
                      variant="contained"
                      disabled={disable}
                    >
                      Subscribe
                    </Button>
                  </Form>
                </div>
              </Card>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscription;
